import { useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Icon from '../../../../controls/Icon';

import Accordion from './Accordion';
import { useUIConfig } from '../Context';
import GetHierarchyBody from './js/HierarchyBody';
import BUILD_TIME_CONFIG_TYPES from '../../../../../config/buildTimeConfigTypes';

const SkeletonUI = ({ maximizeButton }) => {
    const [translate] = useTranslation();
    const history = useHistory();
    const [showValuesInTree, setShowValuesInTree] = useState(true);

    const {
        basePath,
        components,
        blocks,
        applets,
        getMergedTemplate,
        currentOverrides,
        jsxComponents,
        sortComponents,
        selectedLayoutItem,
        selectedLayoutItemType
    } = useUIConfig();

    const selectedLayoutItemExists = useMemo(() => {
        if (!components[selectedLayoutItem] && !blocks[selectedLayoutItem] && !applets[selectedLayoutItem]) {
            return false;
        }

        return true;
    }, [components, blocks, applets, selectedLayoutItem]);

    const hierarchy = useMemo(() => {
        const body = GetHierarchyBody({
            path: [...basePath],
            blocks,
            getMergedTemplate,
            currentOverrides,
            jsxComponents,
            sortComponents,
        });

        return <Accordion
            name={selectedLayoutItem}
            path={[...basePath]}
            showValuesInTree={showValuesInTree}
            isRoot={true}
            isBlock={selectedLayoutItemType === BUILD_TIME_CONFIG_TYPES.BLOCKS}
            isLayoutItem={true}
            body={body}
        />;
    }, [basePath, blocks, currentOverrides, getMergedTemplate, jsxComponents, selectedLayoutItemType, selectedLayoutItem, sortComponents, showValuesInTree]);

    return (
        <div className='fs-7'>
            <div className="d-flex sticky-top bg-light">
                {maximizeButton && <button
                    className="btn btn-sm btn-outline-primary p-0 border-0 mb-2"
                    type="button"
                    onClick={maximizeButton.onClick}
                >
                    <Icon icon={maximizeButton.icon} className="d-block" />
                </button>}
                <Button
                    className='btn-sm me-2 mb-2 ms-auto'
                    onClick={() => setShowValuesInTree(prev => !prev)}
                >
                    {showValuesInTree ? translate("OTM_HIDE_VALUES_IN_TREE") : translate("OTM_SHOW_VALUES_IN_TREE")}
                </Button>
                <Button
                    className='btn-sm me-2 mb-2 ms-2'
                    onClick={() => history.goBack()}
                >
                    {translate('OTM_BACK')}
                </Button>
            </div>
            {
                selectedLayoutItemExists ? hierarchy :
                    <div>
                        <label className="h4">
                            {`${selectedLayoutItem} ${translate("OTM_LAYOUT_ITEM_DOES_NOT_EXIST")}`}
                        </label>
                    </div>
            }
        </div >
    );
};

export default SkeletonUI;